import { render, staticRenderFns } from "./ListUploadedFiles.vue?vue&type=template&id=81f3b050&scoped=true&"
import script from "./ListUploadedFiles.vue?vue&type=script&lang=js&"
export * from "./ListUploadedFiles.vue?vue&type=script&lang=js&"
import style0 from "./ListUploadedFiles.vue?vue&type=style&index=0&id=81f3b050&prod&scoped=true&lang=css&"
import style1 from "./ListUploadedFiles.vue?vue&type=style&index=1&id=81f3b050&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f3b050",
  null
  
)

export default component.exports